import axios from 'axios';
import {backendHost} from '../../config';

export const postNewGame = (params) => {
    return axios.post(`${backendHost}/api/admin/v2/games/game`, params);
};